import SingUpModal from '@/components/Modals/SingUpModal';
import UpgradePlanModal from '@/components/Modals/UpgradePlanModal';
import UpgradeImage from '@/images/SPPlus.png';
import { useAuth } from '@/services/auth';

interface Props {
    open: boolean;
    setOpen: (open: boolean) => void;
}

export const UpgradeModal = ({ open, setOpen }: Props) => {
    const { isAnonymous } = useAuth();

    if (isAnonymous) {
        return (
            <SingUpModal
                text="Sign up to create this Agent"
                mainText="Create an account to build agents and unlock additional features."
                from="agent-avatar-premium"
                isOpen={open}
                onClose={() => setOpen(false)}
            />
        );
    }

    return (
        <UpgradePlanModal
            open={open}
            onClose={() => setOpen(false)}
            from={'SP+ presenter clicked'}
            imageFile={UpgradeImage}
            ctaText={'Upgrade'}
            title={
                <div>
                    Upgrade to higher plan
                    <br />
                    and enjoy premium presenters
                </div>
            }
        />
    );
};
